(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ctr-dynamic-product-badges"] && !Shopify.designMode) return;
  try {
    document.addEventListener("alpine:init", () => {
    Alpine.data("dynamicProductBadges", function (targetSelector) {
        return {
            targetSelector: targetSelector,
            init() {
                const badgesContainer = this.$el.querySelector('.product-badges');
                const targetElements = document.querySelectorAll(this.targetSelector);

                if (!targetElements || targetElements.length === 0) {
                    console.warn('Dynamic Product Badges: No target elements found');
                    return;
                }

                targetElements.forEach(function(element) {
                    element.appendChild(badgesContainer.cloneNode(true));
                });
            }
        };
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ctr-tabs-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener("alpine:init", () => {
        Alpine.data("ctrTabsContent", function () {
            return {
                categories: [],
                tab: null,
                init() {
                    this.categories = this.getCategories();
                    this.tab = this.categories[0].id;
                },
                getCategories() {
                    const categories = this.$refs.tabsContent.querySelectorAll(".ctr-tabs-content-item");
                    return [...categories].map((item) => {
                        return {
                            id: item.dataset.categoryId,
                            name: item.dataset.category
                        };
                    });
                }
            };
        });
    });
  } catch(e) { console.error(e); }
})();

})();
